import { render, staticRenderFns } from "./GoLiveModal.vue?vue&type=template&id=47648d95&scoped=true&"
import script from "./GoLiveModal.vue?vue&type=script&lang=js&"
export * from "./GoLiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47648d95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47648d95')) {
      api.createRecord('47648d95', component.options)
    } else {
      api.reload('47648d95', component.options)
    }
    module.hot.accept("./GoLiveModal.vue?vue&type=template&id=47648d95&scoped=true&", function () {
      api.rerender('47648d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Staging/GoLiveModal/GoLiveModal.vue"
export default component.exports